import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ScreenTrackingService } from '@angular/fire/analytics';
import { RouterOutlet } from '@angular/router';
import { NoInternetService, ToastContainerComponent } from 'nexus-core';
import { RouteValidatorService } from './common/route-validator.service';

@Component({
    selector: 'nexus-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, ToastContainerComponent]
})
export class AppComponent {
  constructor(
    readonly noInternetService: NoInternetService,
    readonly screenTrackingService: ScreenTrackingService,
    readonly routeValidatorService: RouteValidatorService,
  ) {
  }
}
